import { useLang } from "@/lib/i18n";

export const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex rounded-full border border-white/20 overflow-hidden">
      {["en", "es"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`px-3 py-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.15em] transition-colors duration-200 ${
            lang === l ? "bg-[#F26522] text-white" : "text-slate-300 hover:text-white"
          }`}
          data-testid={`dash-lang-toggle-${l}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
